export default __webpack_public_path__ + "static/dropdownBusiness-6aca23f8f2416c303ab8a2a6c3644ac6.png";